import React from 'react'
import { Link } from 'react-router'
import { Content, ExternalLink } from 'components'
import {
  useCommunity,
  isMapEnabled,
  isSchoolPortalEnabled,
  isPartnerPortalEnabled,
  isEducatorEnabled,
  isTeachingArtistEnabled,
} from 'utils'
import {
  ARTIST_PORTAL_ROUTE,
  EDUCATOR_PORTAL_ROUTE,
  PARTNER_PORTAL_ROUTE,
  SCHOOL_PORTAL_ROUTE,
} from 'config'

function Sitemap() {
  const community = useCommunity()
  const mapOn = isMapEnabled(community)
  const schoolOn = isSchoolPortalEnabled(community)
  const partnerOn = isPartnerPortalEnabled(community)
  const educatorOn = isEducatorEnabled(community)
  const artistOn = isTeachingArtistEnabled(community)
  const hasPortals = schoolOn || partnerOn || educatorOn || artistOn

  return (
    <Content className="sitemap-page">
      <header className="map-page-header interior-page sitemap-page__masthead">
        <div className="content-block-container">
          <div className="text-block">
            <p className="sitemap-page__eyebrow">Navigate</p>
            <h1>Site map</h1>
            <p className="sitemap-page__lede">
              Main destinations on this site. Profile pages for schools,
              partners, and teaching artists are also available from search
              results and the map.
            </p>
          </div>
        </div>
      </header>

      <div className="search-block home-block sitemap-page__main">
        <div className="content-block-container">
          <div className="sitemap-page__grid">
            <nav
              className="sitemap-panel"
              aria-labelledby="sitemap-public-heading"
            >
              <h2 id="sitemap-public-heading" className="sitemap-panel__title">
                Public pages
              </h2>
              <ul className="sitemap-panel__list">
                <li>
                  <Link className="sitemap-panel__link" to="/">
                    Home
                  </Link>
                </li>
                {mapOn && (
                  <li>
                    <Link className="sitemap-panel__link" to="/search">
                      Search map
                    </Link>
                  </li>
                )}
              </ul>
            </nav>

            <section
              className="sitemap-panel sitemap-panel--signin"
              aria-labelledby="sitemap-signin-heading"
            >
              <h2 id="sitemap-signin-heading" className="sitemap-panel__title">
                Sign in
              </h2>
              <p className="sitemap-panel__text">
                Use the <strong>Sign In</strong> button in the site header
                {process.env.SIGN_IN_URL ? (
                  <>
                    , or{' '}
                    <ExternalLink
                      className="sitemap-panel__inline-link"
                      href={process.env.SIGN_IN_URL}
                    >
                      open the sign-in page
                    </ExternalLink>
                  </>
                ) : null}
                .
              </p>
            </section>

            {hasPortals && (
              <nav
                className="sitemap-panel sitemap-panel--portals"
                aria-labelledby="sitemap-portals-heading"
              >
                <h2
                  id="sitemap-portals-heading"
                  className="sitemap-panel__title"
                >
                  Portals
                </h2>
                <p className="sitemap-panel__intro">
                  These areas require an account. Use Sign In, or follow links
                  from your welcome email or organization.
                </p>
                <ul className="sitemap-panel__list">
                  {schoolOn && (
                    <li>
                      <Link
                        className="sitemap-panel__link"
                        to={`${SCHOOL_PORTAL_ROUTE}/dashboard`}
                      >
                        School portal
                      </Link>
                    </li>
                  )}
                  {partnerOn && (
                    <li>
                      <Link
                        className="sitemap-panel__link"
                        to={`${PARTNER_PORTAL_ROUTE}/dashboard`}
                      >
                        Partner portal
                      </Link>
                    </li>
                  )}
                  {educatorOn && (
                    <li>
                      <Link
                        className="sitemap-panel__link"
                        to={`${EDUCATOR_PORTAL_ROUTE}/home`}
                      >
                        Educator portal
                      </Link>
                    </li>
                  )}
                  {artistOn && (
                    <li>
                      <Link
                        className="sitemap-panel__link"
                        to={`${ARTIST_PORTAL_ROUTE}/dashboard`}
                      >
                        Teaching artist portal
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            )}
          </div>
        </div>
      </div>
    </Content>
  )
}

export default Sitemap
